import { useCallback, useEffect, useState } from 'react'
import { IoCloseSharp } from 'react-icons/io5'
import Swal from 'sweetalert2'
import { useIntl } from 'react-intl'

import Loading from '../Loading/Loading'
import { SelectWithSearch } from './selectWithSearch'
import { SelectWithAreas } from './selectWithAreas'

import FeedbackAPI from '../../API/Employee/Feedback'
import Employee from '../../API/Lists/employee'
import mapper from './employeeListMapper'

import { LoadingFeedback } from './loadingFeedback'
import { SuccessFeedback } from './successFeedback'

const relations = [
	{ id: 1, name: { es: 'Mi Jefe', pt: 'Meu Chefe' }, key: 'boss' },
	{ id: 2, name: { es: 'Par', pt: 'Par' }, key: 'pairs' },
	{ id: 3, name: { es: 'Mi Equipo', pt: 'Minha Equipe' }, key: 'team' },
	{ id: 4, name: { es: 'Otro Equipo', pt: 'Outra Equipe' }, key: 'other_team' },
]

const AddFeedback = ({ load }) => {
	const getLanguage = useIntl()
	const language = getLanguage.locale === 'PT-BR' ? 'pt' : 'es'
	const { companyId, id } = JSON.parse(localStorage.getItem('user'))

	const [loadingSendFeedback, setLoadingSendFeedback] = useState(false)
	const [openSuccess, setOpenSuccess] = useState(false)
	const [isOpen, setIsOpen] = useState(false)
	const [categories, setCategories] = useState(null)
	const [employees, setEmployees] = useState(null)
	const [disabled, setDisabled] = useState(true)
	const userId = JSON.parse(localStorage.getItem('user'))

	const empty = {
		employeeId: userId.id,
		targetId: null,
		categoryId: null,
		relation: null,
		rating: null,
		comment: '',
	}

	const toggleModal = () => {
		setIsOpen(!isOpen)
		setData({ ...empty })
	}

	const [data, setData] = useState({ ...empty })

	useEffect(() => {
		const { targetId, categoryId, relation, rating } = data

		if (!!targetId && !!categoryId && !!relation && !!rating) {
			setDisabled(false)
			return
		}
		setDisabled(true)
	}, [data])

	const fetchData = useCallback(async () => {
		try {
			const [categoriesList, employeeList] = await Promise.all([FeedbackAPI.getFeedbackCategories(), Employee.getAllByCompany(companyId)])

			setEmployees(employeeList.map(mapper.toDomain).filter(item => item.id !== id))
			setCategories(categoriesList)
		} catch (err) {
			Swal.fire({
				icon: 'error',
				title: 'Oops...',
				text: 'Something went wrong!',
			})
		}
	}, [])

	useEffect(() => {
		fetchData()
	}, [fetchData])

	const handleData = event => {
		const { name, value } = event.target
		setData(prevData => ({
			...prevData,
			[name]: value,
		}))
	}

	const handleRating = index => {
		if (index === 0 && data.rating === 1) {
			setData(prevData => ({
				...prevData,
				rating: 0,
			}))
			return
		}

		const newRating = index + 1
		setData(prevData => ({
			...prevData,
			rating: newRating,
		}))
	}

	const sendData = async () => {
		try {
			setLoadingSendFeedback(true)
			await FeedbackAPI.sendFeedback(data)
			setLoadingSendFeedback(false)
			load()
			setOpenSuccess(true)
		} catch {
			Swal.fire({
				icon: 'error',
				title: 'Oops...',
				text: 'Something went wrong!',
			})
		} finally {
		}
	}

	if (categories && employees) <Loading />

	return (
		<>
			<div
				onClick={toggleModal}
				className='tw-rounded-xl  border tw-cursor-pointer tw-flex tw-items-center tw-text-sm tw-px-4 tw-py-2 tw-bg-purple-500 tw-text-white  tw-whitespace-nowrap'
			>
				+ Agregar Feedback
			</div>

			{isOpen && (
				<div className='tw-fixed tw-inset-0 tw-bg-black/50 tw-flex tw-justify-center tw-items-center tw-z-50 tw-p-0'>
					{!loadingSendFeedback && !openSuccess && (
						<>
							<div className='tw-bg-white tw-rounded-lg tw-shadow-lg  2xl:tw-w-2/5 tw-w-3/5 tw-p-6 tw-relative'>
								<div>
									<div className='tw-flex tw-justify-between tw-items-center tw-border-b tw-pb-3 tw-mb-2'>
										<div className='tw-text-lg tw-font-black'>Nuevo Feedback</div>

										<IoCloseSharp
											size={22}
											onClick={toggleModal}
											className='tw-text-gray-500 hover:tw-text-gray-700 tw-flex tw-items-center tw-cursor-pointer'
										/>
									</div>

									<div className='tw-space-y-4'>
										<div className=''>
											<label className='tw-font-semibold tw-mb-3'>Colaboradores</label>
											<SelectWithAreas
												placeholder='Seleccionar'
												list={employees}
												onChange={handleData}
												name='targetId'
												value={data.colaborador?.value}
											/>
										</div>

										<div className='tw-space-y-2'>
											<label className='tw-font-semibold'>Relación de Trabajo</label>
											<div
												className='tw-flex tw-items-center tw-justify-between tw-p-3 tw-rounded-lg'
												style={{ border: '1px solid #d0d4e4' }}
											>
												{relations.map(relation => (
													<label key={relation.id} className='tw-flex tw-items-center tw-space-x-2 tw-cursor-pointer'>
														<input
															type='radio'
															name='relation'
															value={relation.id}
															checked={data.relation === relation.key}
															onChange={() =>
																setData(prevData => ({
																	...prevData,
																	relation: relation.key,
																}))
															}
															className='tw-w-4 tw-h-4 tw-rounded-full tw-accent-purple-500'
														/>
														<span className='tw-text-base'>{relation.name[language]}</span>
													</label>
												))}
											</div>
										</div>

										<div className='tw-flex tw-items-start tw-space-x-4 tw-min-w-full'>
											<div className='tw-w-full'>
												<label className='tw-font-semibold tw-block tw-mb-2'>Categoria</label>

												<SelectWithSearch
													list={categories}
													onChange={e =>
														handleData({
															target: {
																name: 'categoryId',
																value: e.target.value,
															},
														})
													}
													placeholder='Seleccionar'
													name='categoryId'
												/>
											</div>
											<div>
												<label className='tw-font-semibold tw-block tw-mb-2'>Evaluación</label>
												<div className='tw-flex tw-items-center tw-p-2 tw-rounded-lg' style={{ border: '1px solid #d0d4e4' }}>
													{[...Array(5)].map((_, index) => (
														<svg
															key={index}
															onClick={() => handleRating(index)}
															xmlns='http://www.w3.org/2000/svg'
															viewBox='0 0 26 26'
															fill={data.rating && index < data.rating ? '#FFD700' : '#E5E7EB'}
															className='tw-w-6 tw-h-6 tw-cursor-pointer hover:tw-scale-110 transition-transform'
														>
															<path d='M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z' />
														</svg>
													))}
												</div>
											</div>
										</div>

										<div className='tw-relative tw-w-full'>
											Comentario
											<textarea
												id='comentario'
												className='tw-w-full tw-min-h-[100px] tw-border tw-border-gray-300 tw-rounded-lg tw-p-3 tw-text-base tw-text-gray-700 tw-placeholder-gray-400 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-purple-500'
												placeholder='Escribe tu comentario o sugerencia aquí'
												maxLength={600}
												value={data.comment || ''}
												onChange={e =>
													handleData({
														target: {
															name: 'comment',
															value: e.target.value,
														},
													})
												}
											/>
											<div className='tw-absolute tw-bottom-2 tw-right-3 tw-text-xs tw-text-gray-400'>
												{data.comment.length}/600
											</div>
										</div>
										<div className='tw-relative tw-w-full tw-flex tw-justify-end tw-gap-2'>
											<button onClick={toggleModal} className='tw-p-2 tw-px-4 tw-rounded-md border tw-bg-white '>
												Cancelar
											</button>
											<button
												onClick={sendData}
												disabled={disabled}
												className='tw-p-2 tw-px-4 tw-rounded-md border tw-bg-purple tw-text-white disabled:tw-bg-gray-200 disabled:tw-text-gray-500'
											>
												Enviar Feedback
											</button>
										</div>
									</div>
								</div>
							</div>
						</>
					)}
					{loadingSendFeedback && <LoadingFeedback />}
					{openSuccess && (
						<SuccessFeedback
							close={() => {
								setOpenSuccess(false)
								setIsOpen(false)
							}}
							createNew={() => {
								setOpenSuccess(false)
								setData({ ...empty })
							}}
						/>
					)}
				</div>
			)}
		</>
	)
}

export default AddFeedback
